import React, { useState } from 'react';
import styles from "./Layout.module.css";
import { Outlet } from 'react-router-dom';
import Navigation from '../../components/Navigation/Navigation';
import Sidebar from '../../components/Sidebar/Sidebar';
import Footer from '../../components/Footer/Footer';
import { useUserContext } from '../../components/UserContext/UserContext';

const Layout: React.FC = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { userProfile } = useUserContext();

  return (
    <div className={styles.layout}>
      {/* Sidebar navigation - only for authenticated users */}
      {userProfile && (
        <Sidebar 
          collapsed={sidebarCollapsed} 
          onCollapse={setSidebarCollapsed} 
        />
      )}

      {/* Main content area */}
      <div className={`${styles.mainWrapper} ${userProfile ? (sidebarCollapsed ? styles.sidebarCollapsed : styles.sidebarExpanded) : ''}`}>
        {/* Top header - minimal with user profile */}
        <Navigation />

        <main className={styles.main}>
          <Outlet />
        </main>
        
        <Footer /> 
      </div>
    </div>
  );
};

export default Layout;
